"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GameEventValueType;
(function (GameEventValueType) {
    GameEventValueType[GameEventValueType["STRING"] = 1] = "STRING";
    GameEventValueType[GameEventValueType["FLOAT"] = 2] = "FLOAT";
    GameEventValueType[GameEventValueType["LONG"] = 3] = "LONG";
    GameEventValueType[GameEventValueType["SHORT"] = 4] = "SHORT";
    GameEventValueType[GameEventValueType["BYTE"] = 5] = "BYTE";
    GameEventValueType[GameEventValueType["BOOLEAN"] = 6] = "BOOLEAN";
    GameEventValueType[GameEventValueType["LOCAL"] = 7] = "LOCAL";
})(GameEventValueType = exports.GameEventValueType || (exports.GameEventValueType = {}));
//# sourceMappingURL=GameEvent.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@demostf/demo.js/build/Data/GameEvent.js
// module id = 23
// module chunks = 0